export const title = (companyName: string) => companyName;
export const subTitle = '';
export const body = 'Entrega 1 marca mostrando este QR a un/a cliente';
